import PropTypes from "prop-types";
import { Button, Select, SettingsCard } from "top-component-library";
import { FormRow, SettingHint } from "../styles";

// Mirrors editCustomerProperties.html's "KDS Ticket Color Defaults" card. Saves through the
// same editOwnerProperties round-trip as the rest of the page (default_kds_ticket_colors is
// one of its editable_properties) rather than its own endpoint.
const KdsTicketColorsCard = ({
  colorsByFulfillmentMethod,
  possibleFulfillmentMethods,
  saving,
  onAddColor,
  onRemoveColor,
  onColorChange,
  onSave,
}) => {
  const configuredMethods = Object.keys(colorsByFulfillmentMethod);
  const availableMethods = Object.entries(possibleFulfillmentMethods).filter(
    ([method]) => !configuredMethods.includes(method)
  );

  return (
    <SettingsCard title="KDS Ticket Color Defaults">
      <SettingHint>Customize KDS ticket colors based on fulfillment method for your terminal.</SettingHint>
      {configuredMethods.map((method) => (
        <FormRow key={method}>
          <label htmlFor={`customer-properties-kds-color-${method}`}>
            {possibleFulfillmentMethods[method] ?? method}
          </label>
          <input
            id={`customer-properties-kds-color-${method}`}
            type="color"
            value={colorsByFulfillmentMethod[method]}
            onChange={(event) => onColorChange(method, event.target.value)}
          />
          <Button danger onClick={() => onRemoveColor(method)}>
            Remove
          </Button>
        </FormRow>
      ))}
      <FormRow>
        <label htmlFor="customer-properties-kds-add-method">Set Default KDS Ticket Color for</label>
        <Select id="customer-properties-kds-add-method" value={undefined} onChange={onAddColor}>
          {availableMethods.map(([method, prettyName]) => (
            <Select.Option key={method} value={method}>
              {prettyName}
            </Select.Option>
          ))}
        </Select>
      </FormRow>
      <Button type="primary" loading={saving} onClick={onSave}>
        Save
      </Button>
    </SettingsCard>
  );
};

KdsTicketColorsCard.propTypes = {
  colorsByFulfillmentMethod: PropTypes.objectOf(PropTypes.string).isRequired,
  possibleFulfillmentMethods: PropTypes.objectOf(PropTypes.string).isRequired,
  saving: PropTypes.bool.isRequired,
  onAddColor: PropTypes.func.isRequired,
  onRemoveColor: PropTypes.func.isRequired,
  onColorChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default KdsTicketColorsCard;
